import Header from "@/components/Header";
import Seo, { SITE_URL } from "@/components/Seo";
import Footer from "@/components/Footer";
import CtaBand from "@/components/CtaBand";
import { MENU } from "@/data/site";
import { SERVICE_ORDER, HOME_FAQS } from "@/components/home/data";
import { HomeHero } from "@/components/home/HomeHero";
import { TrustStrip } from "@/components/home/TrustStrip";
import { ServicesBento } from "@/components/home/ServicesBento";
// Below-the-fold sections load as separate chunks so the first paint carries
// only the hero, trust strip and services bento.
import { lazy, Suspense } from "react";
const Cli360Feature = lazy(() => import("@/components/home/Cli360Feature").then((m) => ({ default: m.Cli360Feature })));
const StatsBand = lazy(() => import("@/components/home/StatsBand").then((m) => ({ default: m.StatsBand })));
const ProcessTimeline = lazy(() => import("@/components/home/ProcessTimeline").then((m) => ({ default: m.ProcessTimeline })));
const WhyTestimonials = lazy(() => import("@/components/home/WhyTestimonials").then((m) => ({ default: m.WhyTestimonials })));
const IndustriesGrid = lazy(() => import("@/components/home/IndustriesGrid").then((m) => ({ default: m.IndustriesGrid })));
const InsightsPreview = lazy(() => import("@/components/home/InsightsPreview").then((m) => ({ default: m.InsightsPreview })));
const HomeFaq = lazy(() => import("@/components/home/HomeFaq").then((m) => ({ default: m.HomeFaq })));
import { useBlock } from "@/lib/content";

export default function Home() {
  const home = useBlock("home", null);
  const faqs = home && Array.isArray(home.faqs) && home.faqs.length ? home.faqs : HOME_FAQS;
  const jsonLd = { "@context": "https://schema.org", "@graph": [
    { "@type": "Organization", name: "CLI Secure", url: SITE_URL, logo: `${SITE_URL}/logo.png`, contactPoint: { "@type": "ContactPoint", telephone: "+442033551151", contactType: "customer service", areaServed: "GB", email: "info@clisecure.com" } },
    { "@type": "WebSite", name: "CLI Secure", url: SITE_URL },
    { "@type": "ItemList", itemListElement: SERVICE_ORDER.map((k, i) => { const e = MENU.find((m) => m.key === k); return { "@type": "ListItem", position: i + 1, name: e && e.label, url: e ? `${SITE_URL}${e.href}` : SITE_URL }; }) },
    { "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
  ] };
  return (
    <div className="bg-white">
      <Seo title="CLI Secure — Managed IT, Cyber Security & Connectivity in London" description="London's single partner for managed IT support, 24/7 cyber security, Microsoft 365 & cloud, network consultancy, CCTV & data cabling and business connectivity — with a 4-minute average response time." path="/" jsonLd={jsonLd} />
      <Header />
      <HomeHero />
      <TrustStrip />
      <ServicesBento />
      <Suspense fallback={null}>
      <Cli360Feature />
      <StatsBand />
      <ProcessTimeline />
      <WhyTestimonials />
      <IndustriesGrid />
      <InsightsPreview />
      <HomeFaq />
      </Suspense>
      <CtaBand />
      <Footer />
    </div>
  );
}
